const features = {
    auth: true,
    channels: true,
    versionCheck: true,
    premium: true,
    settings: true,
    favouritesOnboarding: false,
    premiumOnboarding: true,
}

const paymentServices = [
    {
        alias: 'stripe',
        title: 'Credit Card',
        description: 'Visa, Mastercard & AmEx',
        icon: 'credit-card',
    },
    {
        alias: 'paypal',
        title: 'PayPal',
        description: '',
        icon: 'logo-paypal',
    },
]

const donationProducts = [
    {
        amount: 20,
        stripe: {
            url: 'https://donate.stripe.com/14k8xpcEMgvpgYocMP',
        },
        paypal: {
            url: 'https://www.paypal.com/donate/?hosted_button_id=VVB3YVZVKUKQ4',
        }
    },
    {
        amount: 50,
        stripe: {
            url: 'https://donate.stripe.com/9AQbJBcEMenh7nO3ce',
        },
        paypal: {
            url: 'https://www.paypal.com/donate/?hosted_button_id=KT8ZDDM33Q43Y',
        }
    },
    {
        amount: 100,
        stripe: {
            url: 'https://donate.stripe.com/cN26phcEM2Ez5fG5kl',
        },
        paypal: {
            url: 'https://www.paypal.com/donate/?hosted_button_id=EQRPKHZESLUNN',
        }
    },
]

// The keys are persisted to localStorage as `currentOnDemandQualityKey` — renaming one
// silently resets the saved quality preference of every existing user. Copy is free to
// change; the key set is not.
const onDemandQualityOptions = {
    low: {
        title: 'Low',
        subtitle: 'Balance audio quality with low data use. Includes occasional ads.',
        value: '96',
        needsSub: false
    },
    high: {
        title: 'High',
        subtitle: 'Great audio quality. Premium only.',
        value: '128',
        needsSub: true
    },
    best: {
        title: 'HI-FI',
        subtitle: 'High-Resolution audio. Maximum fidelity. Premium only.',
        value: '320',
        needsSub: true
    },
}

// The live radio stream mounts, distinct from the on-demand tiers above.
// Ordered HI-FI first — the first entry is the default.
const radioStreamQualities = [
    { key: 'mp3_high', label: 'HI-FI', bitrate: '320 kbps' },
    { key: 'mp3_mid', label: 'High', bitrate: '128 kbps' },
    { key: 'mp3_low', label: 'Low', bitrate: '96 kbps' },
]

const trialDays = 7 // Number of days to allow for a trial period

const feedbackMessageMemberId = 5

const supportEmail = "support@friskyradio.com"

const nativeApps = {
    iosAppId: `id${import.meta.env.VITE_APPLE_APP_ID}`
}

export {
    features,
    paymentServices,
    donationProducts,
    trialDays,
    onDemandQualityOptions,
    radioStreamQualities,
    feedbackMessageMemberId,
    supportEmail,
    nativeApps
}
